import { useEffect, useState } from "react";

import { Checkbox } from "@newsela/angelou";
import PropTypes from "prop-types";

import { withTrackEvent, actionNames, objectTypes } from "@newsela/snitch";

import VocabToolTipDialog from "./VocabToolTipDialog";
import {
  checkBoxLabelCss,
  containerCss,
} from "./VocabularySupportSetting.style";

const CheckboxWithTrackEvent = withTrackEvent(Checkbox);

const propTypes = {
  assignmentId: PropTypes.string,
  currentContentLevel: PropTypes.object,
  disableVocabularySupport: PropTypes.bool,
  onDisableVocabularySupport: PropTypes.func,
};

const VocabularySupportSetting = ({
  assignmentId,
  currentContentLevel,
  disableVocabularySupport,
  onDisableVocabularySupport,
}) => {
  const [disableVocabularySupportChecked, setDisableVocabularySupportChecked] =
    useState(disableVocabularySupport);

  useEffect(() => {
    setDisableVocabularySupportChecked(disableVocabularySupport);
  }, [disableVocabularySupport]);

  const eventProperties = {
    objectType: objectTypes.assignment,
    actionName: actionNames.update,
    streamProperties: {
      content_type: "Article",
      content_id: currentContentLevel?.id,
      content_ids: [currentContentLevel?.header_id],
      description: `Toggle disable vocabulary support ${disableVocabularySupport ? "on" : "off"}`,
      object_id: assignmentId,
    },
  };

  return (
    <div css={containerCss}>
      <CheckboxWithTrackEvent
        __cssFor={{ root: checkBoxLabelCss(disableVocabularySupportChecked) }}
        checked={disableVocabularySupportChecked}
        label="Disable AI-generated vocabulary supports"
        name="Disable AI-generated vocabulary supports"
        dataProps={{
          "data-qa-selector": `disable_vocabulary_support
        ${disableVocabularySupport ? "on" : "off"}`,
        }}
        onClick={() => {
          setDisableVocabularySupportChecked(
            (prevDisableVocabularySupportChecked) =>
              !prevDisableVocabularySupportChecked,
          );
          onDisableVocabularySupport(!disableVocabularySupportChecked);
        }}
        {...eventProperties}
      />
      <VocabToolTipDialog
        assignmentId={assignmentId}
        currentContentLevelId={currentContentLevel?.id}
      />
    </div>
  );
};

VocabularySupportSetting.propTypes = propTypes;

export default VocabularySupportSetting;
